import React from 'react'
import "./Post.css"
import VideocamIcon from '@material-ui/icons/Videocam'

function PostThumb({postId, imageUrl}) {
    const isVideo = (imageUrl.includes(".mp4")) || (imageUrl.includes(".MP4")) || (imageUrl.includes(".mov")) || (imageUrl.includes(".MOV"));

    return (
        <div className="post__thumbcontainer">
            <div className="post__thumb">
                {isVideo ? (
                    <>
                        <video preload="metadata" src={imageUrl + "#t=0.1"}>
                            <source src={imageUrl} type='video/mp4'></source>
                            Your browser does not support the video tag.
                        </video>
                        <div className="post__thumbBadge" aria-label="Video">
                            <VideocamIcon />
                        </div>
                    </>
                ) : (
                    <img className="post__thumbImage" src={imageUrl} alt="" />
                )}
            </div>
        </div>
    )
}

export default PostThumb
